// source : https://gist.github.com/davidemaser/d0afdbcb21ab0e0571875c8cf9e3ac3a

Shopify.queue = [];
Shopify.moveAlong = function() {
  if (Shopify.queue.length > 0) {
    var request = Shopify.queue.shift();
    Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
  }
  else {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        quantity: parseInt(localStorage.getItem('total_qty'))
      }
    }));
    document.querySelector('.product-block-list__item--accessories').classList.remove('loading');
    var checkboxes = document.querySelectorAll('.custom-accessories-list .accessories-item input[type=checkbox]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
      var pe = checkboxes[i].closest('.accessories-item');
      checkboxes[i].checked = false;
      pe.querySelector('.quantity-selector__value').value = 1;
    }
  }
};
Shopify.addItem = function(id, qty, properties, callback) {
  var params = {
    quantity: qty,
    id: id
  };
  if(properties != false){
    params.properties = properties;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params,
    success: function(response){
      console.log(response);
      if(jQuery('.custom-accessories-list .alert.alert--error').length > 0){
        jQuery('.custom-accessories-list .alert.alert--error').removeClass('alert--error');
      }
      if(typeof callback === 'function'){
        callback();
      }
    },
    error: function(error){
      jQuery('.custom-accessories-list .alert').addClass('alert--error').text(error.responseJSON.description);
      document.querySelector('.product-block-list__item--accessories').classList.remove('loading');
      var checkboxes = document.querySelectorAll('.custom-accessories-list .accessories-item input[type=checkbox]:checked');
      for (var i = 0; i < checkboxes.length; i++) {
        var pe = checkboxes[i].closest('.accessories-item');
        checkboxes[i].checked = false;
        pe.querySelector('.quantity-selector__value').value = 1;
      }
    }
  });
}
function push_to_queue(array){
  var newArray = array.split(',');
  var total_qty = 0;
  for (var i = 0; i < newArray.length; i++) {
    var product = newArray[i].split(':');
    total_qty += parseInt(product[1]);
    localStorage.setItem('total_qty', total_qty);
  }
  for (var i = 0; i < newArray.length; i++) {
    var product = newArray[i].split(':');
    Shopify.queue.push({
      variantId: product[0],
      quantity: product[1]
    });
  }
  Shopify.moveAlong();
};